<mat-card fxLayout="column">
  <mat-card-header>
    <mat-card-title><span [innerHTML]="placeHolder"></span></mat-card-title>
  </mat-card-header>
  <mat-card-content
    [ngStyle]="{backgroundColor: state}">
    <span class="fill-space">
      <span [hidden]="!error"><mat-icon>error</mat-icon> {{tooltip}}</span>
    </span>
  </mat-card-content>
  <mat-card-actions align="end">
    <button *ngIf="displayModelFiles" mat-stroked-button color="primary" (click)="openModels()">Télécharger un exemplaire vierge</button>
    <button *ngIf="canAddMoreFiles()"
            mat-stroked-button
            (click)="fileInput.click()">
      <mat-icon color="accent" matSuffix>add</mat-icon> Ajouter un fichier
    </button>

    <input hidden
           type="file"
           #fileInput
           name="fileInput"
           accept="{{accept}}"
           (change)="preparePJUpload($event)">
  </mat-card-actions>
</mat-card>
